import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import {hostUrl, siteUrl, highTrafficInnerPages } from '../../constants/global';
import {useSelector, useDispatch} from 'react-redux';
import allActions from '../../actions/index';
import { downloadFile } from '../common/Helper';
import Logout from '../common/Logout';

const ModalPopup = () => {
    const modalPopupState = useSelector((state) => state.ModalPopupBucket);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [isAnonymous,setIsAnonymous] = useState(false);
    const [progress,SetProgress] = useState(0);
    const [progressbgcolor,SetProgressBgColor] = useState("red");

    const popupName = modalPopupState.popupname;
    const modalOpen = modalPopupState.open;
    const modalContent = modalPopupState.data;
    var requestButtonName = modalPopupState.data['requestdemo'].download_link.split('||');
    const key = popupName;
    
    var progressStyle = {
        width: progress+'%',
        background: progressbgcolor
    }

    //console.log(modalPopupState, "all modal popups");

    useEffect(() => {
       // console.log("User effect call Modal popup");


            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageData = authlogin ? JSON.parse(authlogin) : "";
            var myHeaders = new Headers();
            var formdata = new FormData();
            formdata.append("username", storageData.user_email);
    
            var requestOptionsForRecorded = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
            };
            /*********get all popups and store in state which load page***********/
            fetch(siteUrl+'/community-rest-functions.php?action=get_user_progress_for_certificate',requestOptionsForRecorded)
            .then((response) => response.json())
            .then(function(actualData){ 
                //console.log(actualData, "Progress Data");  
                if(actualData.status=='success'){
                    var progressData = (actualData.recorded_data*100)/31;
                    //console.log(progressData, 'progress here');
                    /*******get only before dot values*********/
                    var progressDataFinal = progressData.toString().split(".")[0];

                    if(progressDataFinal>100){
                        progressDataFinal = 100;
                    }
                    var bgcolor = "red";
                    if(progressDataFinal>30 && progressDataFinal<60){
                        bgcolor = "orange";
                    }
                    if(progressDataFinal>60){
                        bgcolor = "#00af00";
                    }
                    SetProgress(progressDataFinal);
                    SetProgressBgColor(bgcolor);
                }

            }).catch(rejected => {
                //console.log("in reject");
            });


    });
    
    useEffect(() => {
        //console.log("User effect call Modal popup Second");
        /******Get data Modal data from database and push in modal bucket********/
        if (modalPopupState.datatrack==1) {

            //console.log('Use Effect inner Model center!');

            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageData = authlogin ? JSON.parse(authlogin) : "";
            
            var token = 'Bearer '+storageData.token;

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl
                },
            };

            /*********get all popups and store in state which load page***********/
            fetch(siteUrl+'/community-rest-functions.php?action=all_popup_get',requestOptions)
            .then((response) => response.json())
            .then(function(actualData){ 
                //console.log(actualData, "Popup Get");  
                if(actualData.status=='success'){
                    dispatch( allActions.ModalPopup.pushAllPopupData(actualData.data));
                }

            }).catch(rejected => {
                //console.log("in reject");
            });

        }

    },[]);

    function showRequestDemo(data){
        dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:"requestdemo"}));
    }

    /*******Close Popup*********/
    function closeModal() {
        dispatch(allActions.ModalPopup.hidePopup({}));
    }

    /********Call Form API********/
    function callFormAPI(requestData,formID){
            setLoading(false);
            setIsAnonymous(false);

            if(formID===563){
                var responseString = '<div class="wpcf7-response-output" aria-hidden="true">Thank you for your request. It has been sent.</div>';
            }else if(formID===2073){
                var responseString = '<div class="wpcf7-response-output" aria-hidden="true">Thank you for your feedback. It has been sent.</div>';
            }else{
                var responseString = '<div class="wpcf7-response-output" aria-hidden="true">Thank you for your message.</div>';
            }
            
            document.getElementById("contact-response-"+formID).innerHTML = responseString;
            
            setTimeout(() => {
                document.getElementById("contact-response-"+formID).innerHTML = "";
                closeModal();
            }, 1000);

             /********Submit request demo/trial form***********/
             fetch(siteUrl+'/wp-json/contact-form-7/v1/contact-forms/'+formID+'/feedback',requestData)
             .then((response) => response.json())
             .then(function(actualData){ 
                 if(actualData.status==="mail_sent"){
                    // var responseString = '<div class="wpcf7-response-output" aria-hidden="true">'+actualData.message+'</div>';
                    // document.getElementById("contact-response"+formID).innerHTML = responseString;
                 }else if(actualData.status==="validation_failed"){
                     var responseString = '<div class="wpcf7-response-output error-output" aria-hidden="true">'+actualData.message+'</div>';
                     document.getElementById("contact-response-"+formID).innerHTML = responseString;
                 }else{
                     var responseString = '<div class="wpcf7-response-output warning-output" aria-hidden="true">'+actualData.message+'</div>';
                     document.getElementById("contact-response-"+formID).innerHTML = responseString;
     
                 }

             }).catch(rejected => {
     
             });

    }

    /*********Feedback Submit**********/
    function feedbackSubmit(event){
        event.preventDefault();

        var formID = 2073;

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";

        var firstname = storageData.first_name ? storageData.first_name : "Dummy";
        var lastname = storageData.last_name ? storageData.last_name : "Dummy";
        var email = storageData.user_email ? storageData.user_email : "dummy@ciisummit.com";
        var sessionname = event.target.elements.sessionname.value;
        var rating = event.target.elements.rating.value;
        var feedbackreason = event.target.elements.feedbackreason.value;
        

        var myHeaders = new Headers();
        var formdata = new FormData();
        /*******It Should have same field name which mentioned in contact form 7 in backend*********/
        formdata.append("user-first-name", firstname);
        formdata.append("user-last-name", lastname);
        formdata.append("your-email", email);
        formdata.append("session-name", sessionname);
        formdata.append("radio-speaker", rating);
        formdata.append("feedbackreason", feedbackreason);

        /*******if any fields empty*******/
        if(!firstname || !email || !sessionname || !rating){
            setLoading(false);
            var responseString = '<div class="wpcf7-response-output error-output" aria-hidden="true">Please select field</div>';
            document.getElementById("contact-response-"+formID).innerHTML = responseString;
            return false;
        }else{
            setLoading(true);
            setIsAnonymous(true);
        }
        
        var requestDemoOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
            };

        /*******call form api pass form id*********/
        callFormAPI(requestDemoOptions,formID);
    }


    /*******Product Request demo form********/
    function requestDemoSubmit(event){
        event.preventDefault();

        var formID = 563;

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";

        var firstname = storageData.first_name ? storageData.first_name : "Dummy";
        var lastname = storageData.last_name ? storageData.last_name : "Dummy";
        var email = storageData.user_email ? storageData.user_email : "dummy@ciisummit.com";
        var productname = event.target.elements.productname.value ? event.target.elements.productname.value : "CARBON || DEMO";
        
        var myHeaders = new Headers();
        var formdata = new FormData();
        /*******It Should have same field name which mentioned in contact form 7 in backend*********/
        formdata.append("user-first-name", firstname);
        formdata.append("user-last-name", lastname);
        formdata.append("your-email", email);
        formdata.append("append_product_name", productname);

        /*******if any fields empty*******/
        if(!firstname || !email || !productname){
            setLoading(false);
            var responseString = '<div class="wpcf7-response-output error-output" aria-hidden="true">fields issue</div>';
            document.getElementById("contact-response-"+formID).innerHTML = responseString;
            return false;
        }else{
            setLoading(true);
            setIsAnonymous(true);
        }

        var requestDemoOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };

        callFormAPI(requestDemoOptions,formID);

    }
    
    const ProductLeftData =() => {
        if(modalPopupState.datatrack==0){
            console.log(modalPopupState.data[key].download_link, 'link here');
            return (<div className="column-section 2">
                    <div className="column-image">
                        <img src={modalPopupState.data[key].image} />
                    </div>
                    <h3>{modalPopupState.data[key].title}</h3>
                    <button className="column-download-btn" data-title={modalPopupState.data[key].title} data-type="Brochure" onClick={(event) => downloadFile(event, modalPopupState.data[key].download_link)} ><span className="material-icons-outlined">file_download</span> Download</button>

            </div>)
        }
    }
    const ProductBookLet = () => {
        return (<div className="column-section 1">                     
                    <div className="column-image"> 
                        <img src="https://community-wp.ciisummit.com/wp-content/uploads/2023/02/aboutCT-thub.jpg" />
                    </div>
                    <h3>About ClearTrail Technologies</h3>
                    <button className="column-download-btn" data-title="About ClearTrail Technologies" data-type="Brochure" onClick={(event) => downloadFile(event, 'https://community-wp.ciisummit.com/wp-content/uploads/protected-files/About-ClearTrail-Technologies.pdf')} ><span className="material-icons-outlined">file_download</span> Download </button>
            </div>
            );
    }

    return (
        <>
            {/***********Data Content***************/}
            {popupName === "datacontent" &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false}
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container">
                        <div className="modal-text-box" dangerouslySetInnerHTML={{__html: modalPopupState.data[key].content}} />
                </div>
            </Modal>
            }

            {/**********Feedback*************/}
            {popupName === "feedback" &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false}
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container">
                    <h2 className="feedback-title">{modalPopupState.data.feedback.title}</h2>
               

                    <form onSubmit={feedbackSubmit}>
                        

                                <input type="hidden" name="sessionname" value={modalPopupState.data[key].title} />

                                <div className="feedback-field-col">
                                    <label className="form-label">How was your overall experience of this session? <span>*</span></label>
                                    <div className="feedback-options">
                                        <div className="feedback-options-col">
                                            <input type="radio" id="excellent" name="rating" value="Excellent" />
                                            <label htmlFor="excellent">Excellent</label>
                                        </div>

                                        <div className="feedback-options-col">
                                            <input type="radio" id="verygood" name="rating" value="Very Good" />
                                            <label htmlFor="verygood">Very Good</label>
                                        </div>

                                        <div className="feedback-options-col">
                                            <input type="radio" id="average" name="rating" value="Average" />
                                            <label htmlFor="average">Average</label>
                                        </div>

                                        <div className="feedback-options-col">
                                            <input type="radio" id="belowaverage" name="rating" value="Below Average" />
                                            <label htmlFor="belowaverage">Below Average</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="feedback-field-col">
                                    <label className="form-label">Please provide your comments on the session.(optional)</label>
                                    <textarea rows="5" cols="60" name="feedbackreason"></textarea>
                                </div>

                                <div className="request-demo-submit">
                                    <button type="submit" disabled={isAnonymous ? true : false} className="submit-btn">{loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Submit</button>
                                    <button type="button" className="cancel-request-btn" onClick={closeModal}>Cancel</button>
                                </div>
                    

                        <div id="contact-response-2073" className="contact-response">
                            {/********Response Message will append*********/}
                        </div>

                    </form>


                </div>

            </Modal>
            }

            {/**********Product Popups***********/}
            {(popupName === "carbon" || popupName === "webtrail" || popupName === "comtrail" || popupName === "comtrailnx" || popupName === "snapshot" || popupName === "titan") &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false}
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container">
                <div className="column-box">
                <ProductLeftData />
                <ProductBookLet />
                </div>
                <button type="button" className="btn open-details" onClick={() => showRequestDemo(popupName)}>Request {requestButtonName[1]}</button>
                </div>
            </Modal>
            }


            {/**********Request Demo Popup HTML***********/}
            {popupName === "requestdemo" &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false}
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container request-demo-popup">
                    <h3>{modalPopupState.data[key].title ? modalPopupState.data[key].title : "You are about to submit a request for Product Demonstration."}</h3>
                    <h3>आप Product Trial के लिए अनुरोध भेजने वाले हैं।</h3>

                    <form onSubmit={requestDemoSubmit}>
                        <div className="request-demo-submit">
                                <input type="hidden" name="productname" value={modalPopupState.data[key].download_link}/>
                                <button type="submit" disabled={isAnonymous ? true : false} className="submit-btn">{loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Submit "Confirm (पुष्टि करें)"</button>
                                <button type="button" className="cancel-request-btn" onClick={closeModal}>Cancel (रद्द करें)</button>
                        </div>
                    

                        <div id="contact-response-563" className="contact-response">
                             {/********Response Message will append*********/}
                        </div>

                    </form>
                </div>
            </Modal>
            }

            {/**********Video Show POPUP***********/}
            {popupName === "videoshow" &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false} className="video-show-popup"
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container">
                    <iframe src={modalPopupState.data.videoshow.download_link}></iframe>                   
                </div>
            </Modal>
            }

            {/**********AlertBox***********/}
            {popupName === "alertbox" &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false} className="alert-box-popup"
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container">

                    <h3>Session Expired</h3>
                    <div className="warning-box">
                        <p><b>Warning</b></p>
                        <p>Session timeout. Please login again!</p>
                    </div>
                    {/* {modalPopupState.data.alertbox.title} */}
                    <div className="logout-button"><Logout layout="alertbox"/></div>
                </div>
            </Modal>
            }


            {/**********FAQ POPUP for certificate***********/}
            {popupName === "faq-certificate" &&
            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                ariaHideApp={false} className="faq-certificate"
            >
                <button className="modalClose" onClick={closeModal}><span className="material-icons-outlined">close</span> Close</button>
                <div className="modal-container">

                    <h3>You're almost there!!</h3>
                    <div className="faq-certification-container">

                    Please finish watching 60% of the sessions from the archives to become eligible for the certificate.

                    <div className="progressbar"><span style={progressStyle}><div className="progress-present">{progress}%</div></span></div>

                    </div>
                </div>
            </Modal>
            }
        </>
    )
}

export default ModalPopup;
